// extracted by mini-css-extract-plugin
module.exports = {"medium":"shadow_medium__nDNbv","light":"shadow_light__kNs49","drop":"shadow_drop__E2cQt","none":"shadow_none__22Ar4"};